module.exports = __webpack_public_path__ + "public/images/testimony.8ecc40e9f2a84cc1f45bd27fd8009569.jpg";